import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslocoDirective } from '@jsverse/transloco';
import { ColorScheme, ColorSchemeService } from '../../../core/scheme/color-scheme.service';

const NEXT_SCHEME: Record<ColorScheme, ColorScheme> = {
  auto: 'light',
  light: 'dark',
  dark: 'auto',
};
const SCHEME_ICON: Record<ColorScheme, string> = {
  auto: 'fa:circle-half-stroke',
  light: 'fa:sun',
  dark: 'fa:moon',
};

/** ปุ่มสลับโหมดสว่าง/มืด/ตามระบบ */
@Component({
  selector: 'app-scheme-toggle',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconButton, MatIcon, MatTooltip, TranslocoDirective],
  template: `
    <ng-container *transloco="let t">
      <button
        mat-icon-button
        type="button"
        class="touch-target"
        [matTooltip]="t('scheme.' + scheme())"
        [attr.aria-label]="t('scheme.' + scheme())"
        (click)="toggle()"
      >
        <mat-icon [svgIcon]="icon()" />
      </button>
    </ng-container>
  `,
})
export class SchemeToggle {
  private readonly colorScheme = inject(ColorSchemeService);

  readonly scheme = this.colorScheme.scheme;
  readonly icon = computed(() => SCHEME_ICON[this.scheme()]);

  toggle(): void {
    this.colorScheme.setScheme(NEXT_SCHEME[this.scheme()]);
  }
}
